import React, { useEffect, useState } from "react";
import Section from "../../components/layout/Section";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import ExpandableCodeBlock from "../../components/layout/ExpandableCodeBlock";

const UserscriptPage = () => {
  const [code, setCode] = useState("");

  useEffect(() => {
    fetch("/userscript.txt")
      .then((res) => res.text())
      .then(setCode)
      .catch((err) => {});
  }, []);

  return (
    <Box sx={{ p: 2.5 }}>
      <Section id="intro" title="Lebron Values Userscript">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: June 2026
        </Typography>
        <Box sx={{ textAlign: 'center' }}>
          <Button
            size="large"
            href="https://greasyfork.org/en/scripts/540477-neopets-lebron-nc-values"
            variant="contained"
          >
            get the userscript!
          </Button>

          <Typography
            variant="caption"
            color="secondary"
            sx={{
              textAlign: "center",

              mb: 2,
              display: "block"
            }}
          >
            (this button leads externally to greasyfork)
          </Typography>
        </Box>

        <Typography paragraph>
          If you want values to show up on site and on some fansites like jn and dti, you can install our userscript! When correctly installed, values will show up under item images like this:
        </Typography>

        <Box sx={{ textAlign: "center", m: 2, mb: 3 }}>
          <img src={require('../../assets/scriptexample.png')} alt="example of the userscript where values are displayed below images" style={{ maxWidth: "95%", borderRadius: 5 }} />
        </Box>


        <Typography paragraph>
          If you prefer to remain on this site, the raw code is also posted below. Please take note of the credits! Some of you may be familiar with the script's predecessor, and in short, this is basically the same script with a few modifications to support tokens and nonwearable items. Big thank you to Kaye for giving our team permission to reuse it :)
        </Typography>
        <ExpandableCodeBlock code={code} />

      </Section>
    </Box>
  );
};

export default UserscriptPage;